import type { Getter, Setter } from 'jotai';
import type { UndoRedoActionCommand } from '../../../../../modernization-common/undo-redo/types';
import { removeQuestionFromDynamicAnswerSegments } from '../../../studio-store/utils/dynamic-answer-utils';
import { annotationMetadataAtom } from '../../annotation-atoms';
import type { DeleteAnnotationAttributeEventPayload } from '../events';
import { reviseDynamicAnswers } from './dynamic-answers-mutation';
export const deleteAnnotationAttributeCommandFactory = (get: Getter, set: Setter): UndoRedoActionCommand<DeleteAnnotationAttributeEventPayload, void> => {
  let restoreDynamicAnswers: () => void = () => {};
  return {
    execute: payload => {
      const {
        annotationId,
        questionId,
        frameSpan
      } = payload;
      const metadata = get(annotationMetadataAtom).get(annotationId);
      restoreDynamicAnswers = reviseDynamicAnswers(set, annotationId, metadata?.dynamicAnswers, current => removeQuestionFromDynamicAnswerSegments(current, questionId, frameSpan));
    },
    undo: () => {
      restoreDynamicAnswers();
    }
  };
};